import { LinearProgress, styled } from "@mui/material";

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  top: 100,
  height: 5,
  borderRadius: 3,
  [`& .MuiLinearProgress-bar`]: {
   background: 'radial-gradient(82.62% 99.48% at 17.38% 61.42%, #677DE5 4.96%, #7862BB 53.66%, #A85EAF 100%)'
  },
}));

export const ComponentLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 3,
  width: 400,
  [`& .MuiLinearProgress-bar`]: {
   background: 'linear-gradient(90deg, #677DE5 5%, #7862BB 54%, #A85EAF 100%)'
  },
}));
